/** Buchungs- und Lead-Formulare haben einen eigenen Laufzeitrahmen ohne Verwaltungs-Update. */
export function isPublicWidgetLocation(location: Pick<Location, "pathname" | "hash">): boolean {
  const path = location.hash.startsWith("#/") ? location.hash.slice(1).split("?")[0] : location.pathname;
  return /^\/(?:book|lead)\/[^/]+\/?$/.test(path);
}

export function isPublicWidgetPage(): boolean {
  return typeof window !== "undefined" && isPublicWidgetLocation(window.location);
}
